/** localStorage key holding the ms-epoch timestamp this browser's Stripe Link trust was last revoked. */
export const LINK_TRUST_REVOKED_KEY = 'mealz.stripe_link.trust_revoked_at'
/** A revocation older than this is treated as expired; a provable identity-bound event resets it. */
export const LINK_TRUST_REVOKED_TTL_MS = 60 * 60 * 1000
/** Web Locks API lock name serializing the revocation read-merge-write critical section across tabs. */
export const LINK_TRUST_LOCK_NAME = 'mealz:stripe-link-trust-revocation'
